import React from 'react';
import {Helmet} from 'react-helmet';
import ReactMarkdown from 'react-markdown';
import cropImagesHeader from './crop-images-header.md';
import cropImagesSectionOne from './crop-images-section-one.md';
import cropImagesSectionTwo from './crop-images-section-two.md';
import cropImagesHowToHeader from './crop-images-how-to-header.md';
import cropImagesHowToStepOne from './crop-images-how-to-step-one.md';
import cropImagesHowToStepTwo from './crop-images-how-to-step-two.md';
import cropImagesHowToStepThree from './crop-images-how-to-step-three.md';
import cropImagesHowToStepFour from './crop-images-how-to-step-four.md';

import {Features} from '../..';

import styles from '../styles';

import image1 from './assets/crop-page-1.jpg';
import image2 from './assets/crop-page-2.jpg';

const CropImages = () => (
  <Features customMasthead={cropImagesHeader}>
    <Helmet>
      <title>Crop photos online using ImageResize.org</title>
      <meta
        name="description"
        content="Online tool to easily crop photos. Use a custom aspect ratio or crop freely to adjust your photo compositions."
      />
    </Helmet>
    <div className='container'>
      <div className='twoSections verticallyCentered content'>
        <ReactMarkdown className='section' source={cropImagesSectionOne} />
        <div className='section'>
          <img className={styles.featureImage} src={image1} alt="" />
        </div>
      </div>
    </div>
    <div className='darkSection'>
      <div className='twoSections verticallyCentered container'>
        <div className='section'>
          <img className={styles.featureImage} src={image2} alt="" />
        </div>
        <ReactMarkdown className='section' source={cropImagesSectionTwo} />
      </div>
    </div>
    <div className='container'>
      <ReactMarkdown className='section center' source={cropImagesHowToHeader} />
    </div>
    <div className={styles.howToGrid}>
      <div className={styles.howToItem}>
        <div className={styles.step}>01</div>
        <ReactMarkdown source={cropImagesHowToStepOne} />
      </div>
      <div className={styles.howToItem}>
        <div className={styles.step}>02</div>
        <ReactMarkdown source={cropImagesHowToStepTwo} />
      </div>
      <div className={styles.howToItem}>
        <div className={styles.step}>03</div>
        <ReactMarkdown source={cropImagesHowToStepThree} />
      </div>
      <div className={styles.howToItem}>
        <div className={styles.step}>04</div>
        <ReactMarkdown source={cropImagesHowToStepFour} />
      </div>
    </div>
  </Features>
);

export default CropImages;



// WEBPACK FOOTER //
// ./src/containers/Features/CropImages/index.jsx